(function() {
    "use strict";

    angular
        .module("P3in")
        .filter("lb2br", lb2br);

    lb2br.$inject = [];

    function lb2br() {
        return function (input) {
            return input.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }
    }
})()


// WEBPACK FOOTER //
// ./src/app/modules/P3in/directives/lb2br.js